import { Router } from 'vue-router'

import { useUIStore } from '@/popup/store/UIStore'

/**
 * Runs after completing an approval action (cancel/confirm).
 * It checks whether to close the popup (no more approvals, external window).
 * Next it redirects to the last saved path if there are no approvals, otherwise
 * it redirects to the home view to handle the next approval.
 */
export const redirectAfterApproval = (
  router: Router,
  nonStashedApprovalsLength: number,
  lastPath?: string
) => {
  const hasAnyApprovals = nonStashedApprovalsLength > 0
  if (!hasAnyApprovals && useUIStore().isPopup) {
    return window.close()
  }
  !hasAnyApprovals && lastPath ? router.push(lastPath) : router.push('/home')
}
